/**评价模块 */
import request from '../request/http';
/**获取问卷评价列表 */
export function GetQuestionnairesEvaluateList(){
    return request({
        url: '/sp/evaluate/getQuestionnairesEvaluateList',
        method: 'post',
    })
}
/**用户评价 */
export function UserEvaluate(data){
    return request({
        url: '/sp/evaluate/userEvaluate',
        method: 'post',
        data
    })
}
/**分页查询用户评价 */
export function PageQueryEvaluate(data){
    return request({
        url: '/sp/evaluate/pageQueryEvaluate',
        method: 'post',
        data
    })
}